import { withAuthenticationRequired } from '@auth0/auth0-react';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { WorklistSurface } from '../atoms/WorklistSurface';
import { GdataHeader } from '../molecules/GdataLayout/GdataHeader';
import { RequireRole } from './forbidden/RequireRole';

const GdataLayout = () => {
  return (
    <RequireRole>
      <WorklistSurface>
        <GdataHeader />
        <div className="px-6 pb-14 pt-8">
          <Outlet />
        </div>
      </WorklistSurface>
    </RequireRole>
  );
};
export default withAuthenticationRequired(GdataLayout);
